import { postRequest, URL } from "shared/utils";
import * as types from "./actionTypes";

// requestBody matches the backend's home dashboard filter contract - see
// pages/Home/components/Charts/homeFilters.js#buildHomeFilterRequest.
export function getHomePageData(requestBody) {
  const url = `${URL.page}/home`;

  const request = postRequest(url, requestBody);

  return {
    type: types.GET_HOME_PAGE_DATA,
    payload: request,
  };
}
